import * as React from "react";
import AppBody from "../../../components/AppBody";
import Button from "../../../components/connect-ui/Button";
import Container from "../../../components/connect-ui/Container";
import Header from "../../../components/Header";
import useMemoryHistory from "../../../hooks/useMemoryHistory";
export default function BasePoliciesMissingData(_a) {
    var continueRoute = _a.continueRoute, backRoute = _a.backRoute;
    var push = useMemoryHistory().push;
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        React.createElement(AppBody, { centerContent: true },
            React.createElement(Container, null,
                React.createElement("h1", { className: "mb-2 text-2xl font-bold" }, "We were unable to find your insurance policy."),
                React.createElement("p", { className: "text-black-300" }, "You can still enter your information manually to continue."),
                React.createElement("div", { className: "mt-20 space-y-2" },
                    React.createElement(Button, { onClick: function () { return push(continueRoute); } }, "Continue Manually"),
                    React.createElement(Button, { variant: "outlined", onClick: function () { return push(backRoute); } }, "Back to insurer selection"))))));
}
